import {
   FeatureNotEnabledFault,
   PromptTimeoutFault,
   PromptUnavailableFault,
   QuotaExceededFault,
   TextRedactCommand,
   TextRedactionResult,
} from '@dreryk/egabinet-ai-assistant-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { Choice } from '@dreryk/watermelon';

import { dispatchAiAssistantRedactionTokensQuotaExceededSnackbarEvent } from '../shared/dispatchAiAssistantTokensQuotaSnackbarEvent';

import { AI_ASSISTANT_FAULT_HANDLERS } from './faultHandlers';

type RedactionFaultUnion = FeatureNotEnabledFault | QuotaExceededFault | PromptUnavailableFault | PromptTimeoutFault;

export type RedactionCommandInput = {
   field: string;
   text: string;
   context?: string;
};

type UseTranscriptionRedactionOptions = {
   onSuccess?: (result: TextRedactionResult) => void;
};

/**
 * Text and context are passed as execute() parameters — not as hook options.
 * This avoids the stale closure problem where text would be '' at hook initialization.
 */
export const useTranscriptionRedaction = (
   options: UseTranscriptionRedactionOptions = {}
): UseCqrsCommandResult<TextRedactionResult, RedactionCommandInput, RedactionFaultUnion> => {
   return useCqrsCommand<TextRedactionResult, RedactionCommandInput, RedactionFaultUnion>(
      (input) => {
         const command = new TextRedactCommand();
         command.field = input.field;
         command.text = input.text;
         command.context = Choice.withUseDefaultIfNull(input.context ?? null);
         return command;
      },
      {
         onSuccess: options.onSuccess,
         onFault: {
            ...AI_ASSISTANT_FAULT_HANDLERS,
            'egabinet-ai-assistant-frontend-api:QuotaExceededFault': dispatchAiAssistantRedactionTokensQuotaExceededSnackbarEvent,
         },
      }
   );
};
